import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { formatTimeLeftSimple } from 'lib/dateDisplay';

import { timeLeft, timeLeftText } from './HistoryEntryEditTimeLeft.less';

class HistoryEntryEditTimeLeft extends Component {
  constructor(props) {
    super(props);
    this.initialTime = props.time;
    this.state = { time: formatTimeLeftSimple(this.initialTime) };
  }

  componentDidMount() {
    this.timer = setInterval(() => this.newTime(), 10000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  newTime() {
    this.setState({
      time: formatTimeLeftSimple(this.initialTime),
    });
  }

  render() {
    return (
      <h6 className={timeLeftText}>
        {this.state.time.hrs >= 0 && <FormattedMessage id="historyEntry.editTimeLeft" />}
        {this.state.time.hrs > 0 && (
          <FormattedMessage
            id="historyEntry.editTimeLeftHrs"
            values={{ hrs: <span className={timeLeft}>{this.state.time.hrs}</span> }}
          />
        )}
        {this.state.time.hrs >= 0 && (
          <FormattedMessage
            id="historyEntry.editTimeLeftMins"
            values={{ mins: <span className={timeLeft}>{this.state.time.mins}</span> }}
          />
        )}
        {this.state.time.hrs < 0 && <FormattedMessage id="historyEntry.editTimeLeftNone" />}
      </h6>
    );
  }
}

HistoryEntryEditTimeLeft.propTypes = {
  time: PropTypes.number.isRequired,
};

export default HistoryEntryEditTimeLeft;
